import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivityDto } from '@bo-client/shared/models/activityDto';
import { Observe } from '@bo-client/shared/observables.utils';
import { Observable, Subject } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SortService } from '@bo-client/shared/services/sort.service';
import { takeUntil } from 'rxjs/operators';
import { MatDialogSize } from '@bo-client/shared/constants/mat-dialog-size';
import { ActivityDetailComponent } from '@bo-client/shared/components/activity-detail/activity-detail.component';

@Component({
  selector: 'app-show-last-activity',
  templateUrl: './show-last-activity.component.html',
  styleUrls: ['./show-last-activity.component.scss']
})
export class ShowLastActivityComponent implements OnInit, OnDestroy {
  @Input() activities: ActivityDto[];
  @Observe('activities') activities$: Observable<ActivityDto[]>;

  public activity: ActivityDto = null;

  private compUnsubs$ = new Subject<void>();

  constructor(private matDialog: MatDialog, private sortService: SortService) {}

  ngOnInit(): void {
    this.activities$.pipe(takeUntil(this.compUnsubs$)).subscribe((activities) => {
      this.activity = this.sortService
        .sortByDate(activities, 'down', 'createdDate')
        .filter((x) => x.type == 'AUDIT_ACTIVITY' && x.stateTo)[0];
    });
  }

  public showEmail(activity: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'show-EMail';
    dialogConfig.maxHeight = MatDialogSize.maxHeight;
    dialogConfig.width = MatDialogSize.width;
    dialogConfig.data = activity;
    this.matDialog
      .open(ActivityDetailComponent, dialogConfig)
      .afterClosed()
      .pipe(takeUntil(this.compUnsubs$))
      .subscribe(
        (result) => {
          if (result) {
          }
          console.log(result);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
